<template>
  <Modal
    @close="closeModal()"
    :closeIcon="true"
    size="sm"
    :withoutFooter="true"
    class="select-none"
  >
    <div slot="body">
      <Heading>New Promotion Event</Heading>

      <div class="mt-4">
        <fieldset>
          <label for="name">Event Name<small>*</small></label>
          <input
            type="text"
            class="input mt-2"
            id="name"
            v-model="form.name"
            required
          />
        </fieldset>
      </div>

      <div class="flex justify-between mt-8">
        <StyledButton @click="submit()" type="primary">Save</StyledButton>
        <StyledButton @click="closeModal()">Cancel</StyledButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import Heading from "@/components/common/Heading";
import StyledButton from "@/components/common/controls/StyledButton";
import { VueEditor } from "vue2-editor";
import ApiV1 from "@/api/api_v1.0.js";

export default {
  name: "CreateUpdatePromotionModal",
  props: ["promotionid"],
  components: {
    Modal,
    Heading,
    StyledButton,
    VueEditor
  },

  data() {
    return {
      form: {
        name: ""
      }
    };
  },

  methods: {
    async submit() {
      // create order
      const response = await ApiV1.createPromotionEvent(
        this.promotionid,
        this.form
      );
      this.resetForm();
      this.closeModal();

      // redirect to edit event
      this.$router.push({
        name: "orders.edit.details",
        params: { uuid: response.data.uuid }
      });
    },

    resetForm() {
      this.form.name = "";
    },

    closeModal() {
      this.$emit("close");
    }
  }
};
</script>
